export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'erf.delete_erfmapping',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:erf:erfmapping:export',
    }
  }
}